import { Button } from '@mui/material';
import RoomPrice from '../../../helpers/RoomPrice';
import PurchaseButtons from './PurchaseButtons';
import RoomCardBlock from './RoomCardBlock';

const RoomBookingCard = ({
  index,
  room,
  compare,
  setUsdUserTooltip,
  usdUserTooltip,
  handleMouseEnter,
  handleMouseLeave,
  data,
  priceTooltip,
  setPriceTooltip,
  total_nights,
  total_passangers,
  canBuy,
  canBook,
  canBookNoRef,
  cancelationFee,
  clickedBuyButton,
  loading,
  screenSize,
  handleCancelableBuy,
  handleCancelable,
  handleNoCancelableBuy,
  handleNoCancelable,
  setShowModal,
  integration,
  business_types,
  validationError,
  hotelCancelationFeeError,
  price,
}) => {
  return (
    <RoomCardBlock>
      {room.rooms[0].availability !== 'ORQ' && (
        <RoomPrice
          compare={compare}
          index={index}
          setUsdUserTooltip={setUsdUserTooltip}
          usdUserTooltip={usdUserTooltip}
          handleMouseEnter={handleMouseEnter}
          handleMouseLeave={handleMouseLeave}
          supplier={data.supplier}
          priceTooltip={priceTooltip}
          setPriceTooltip={setPriceTooltip}
          total_nights={total_nights}
          total_passangers={total_passangers}
          id_product={room.id_product}
          price={price}
          business_types={business_types}
          integration={integration}
        />
      )}

      {room.rooms[0].availability === 'ORQ' ? (
        <Button
          id={`askButton${index}`}
          color="primary"
          variant="contained"
          onClick={() => setShowModal(true)}
          sx={{
            my: '10px',
            fontSize: '16px',
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: '8px',
            height: '40px',
          }}
        >
          Consultar
        </Button>
      ) : (
        <PurchaseButtons
          canBuy={canBuy}
          canBook={canBook}
          canBookNoRef={canBookNoRef}
          cancelationFee={cancelationFee}
          clickedBuyButton={clickedBuyButton}
          index={index}
          loading={loading}
          screenSize={screenSize}
          handleCancelableBuy={handleCancelableBuy}
          handleCancelable={handleCancelable}
          handleNoCancelableBuy={handleNoCancelableBuy}
          handleNoCancelable={handleNoCancelable}
          validationError={validationError}
          hotelCancelationFeeError={hotelCancelationFeeError}
        />
      )}
    </RoomCardBlock>
  );
};

export default RoomBookingCard;
